import { render, staticRenderFns } from "./productPlan.vue?vue&type=template&id=159d2775&scoped=true"
import script from "./productPlan.vue?vue&type=script&lang=js"
export * from "./productPlan.vue?vue&type=script&lang=js"
import style0 from "./productPlan.vue?vue&type=style&index=0&id=159d2775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159d2775",
  null
  
)

export default component.exports